import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlarmAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"alarm_add"}/>
}
